import { render, staticRenderFns } from "./ReferencesItem.vue?vue&type=template&id=346f5b00&scoped=true&"
import script from "./ReferencesItem.vue?vue&type=script&lang=js&"
export * from "./ReferencesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f5b00",
  null
  
)

export default component.exports